'use client';

import { useEffect } from 'react';

export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    useEffect(() => {
        console.error('[SnapGRID Error]', error);
    }, [error]);

    return (
        <div style={{
            minHeight: '60vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '40px 24px',
            fontFamily: "'Inter', sans-serif",
        }}>
            <div style={{ maxWidth: 480, textAlign: 'center' }}>
                <div style={{
                    width: 64, height: 64, margin: '0 auto 20px',
                    borderRadius: 16,
                    background: 'linear-gradient(135deg, rgba(239,68,68,0.15), rgba(239,68,68,0.05))',
                    border: '1px solid rgba(239,68,68,0.2)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 28,
                }}>
                    ⚠️
                </div>
                <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>
                    페이지 로딩 중 오류가 발생했습니다
                </h2>
                <p style={{ fontSize: 14, color: '#64748b', marginBottom: 24, lineHeight: 1.6 }}>
                    일시적인 문제일 수 있습니다. 아래 버튼을 클릭하여 다시 시도해주세요.
                </p>

                {process.env.NODE_ENV === 'development' && (
                    <pre style={{
                        padding: 12, borderRadius: 8,
                        background: 'rgba(239,68,68,0.06)',
                        border: '1px solid rgba(239,68,68,0.15)',
                        fontSize: 11, color: '#ef4444',
                        textAlign: 'left', overflow: 'auto', maxHeight: 120,
                        marginBottom: 16,
                    }}>
                        {error.message}
                    </pre>
                )}

                <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
                    <button
                        onClick={reset}
                        style={{
                            padding: '10px 24px', borderRadius: 10,
                            background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
                            color: '#fff', border: 'none', cursor: 'pointer',
                            fontWeight: 600, fontSize: 14,
                        }}
                    >
                        다시 시도
                    </button>
                    <button
                        onClick={() => window.location.href = '/'}
                        style={{
                            padding: '10px 24px', borderRadius: 10,
                            background: 'rgba(255,255,255,0.05)',
                            color: '#94a3b8',
                            border: '1px solid rgba(255,255,255,0.1)',
                            cursor: 'pointer', fontWeight: 500, fontSize: 14,
                        }}
                    >
                        홈으로
                    </button>
                </div>
            </div>
        </div>
    );
}
